export function ensureAdfoxApiAvailable() {
  if (!window.yaContextCb) {
    window.yaContextCb = [];
    var script = window.document.createElement('script');
    script.src = 'https://yandex.ru/ads/system/context.js';
    script.async = true;
    window.document.body.appendChild(script);
  }
}